import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5db5fe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "well" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Upload a new photo", -1))
const _hoisted_4 = { class: "form-field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Image", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "form-field"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "File Type", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "form-field"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Make Profile Picture", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Select if you would like to make this the profile picture.", -1))
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 2,
  style: {"color":"green"}
}
const _hoisted_16 = {
  key: 0,
  class: "well margin text-center"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Profile Picture", -1))
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 0,
  class: "left"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Current Photos", -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "row"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = ["onClick"]

import { ref } from "vue";
// import { storeToRefs } from "pinia";
import BaseSpinner from "@/components/BaseSpinner.vue";
import { storeToRefs } from "pinia";
import api from "@virgodev/bazaar/functions/api";
import { ImageInterface } from "../types/customers";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: Number,
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);
const store = useStore();
const { userData } = storeToRefs(store);
// const router = useRouter();
const chosenAttachment = ref();
const api_settings = userData.value.chosenFacility.api_settings;
const attachmentTypes = ref([
  {
    description: "Driver's License",
    value: "10",
  },
  {
    description: "Lease Agreement",
    value: "20",
  },
  {
    description: "Miscellaneous",
    value: "30",
  },
  {
    description: "Property Damage",
    value: "40",
  },
  {
    description: "Tenant Id",
    value: "50",
  },
  {
    description: "Unit Damage",
    value: "60",
  },
  {
    description: "Vehicle",
    value: "70",
  },
  {
    description: "Insurance",
    value: "80",
  },
  {
    description: "Address Change",
    value: "90",
  },
  {
    description: "Returned Mail",
    value: "100",
  },
  {
    description: "Diposal Sale",
    value: "110",
  },
  {
    description: "Delinquency",
    value: "120",
  },
  {
    description: "Import",
    value: "130",
  },
]);

const profilePicture = ref("");
const setToProfilePicture = ref(false);
const formFields = ref({
  customer_id: ref(),
  image: ref(),
});
const showSuccess = ref(false);
const customer = ref();
const photos = ref(Array<ImageInterface>());
const errors = ref("");

const fileInput = ref<HTMLInputElement | null>(null);

function uploadImage(e: Event) {
  const fileInput = e.target as HTMLInputElement;
  const file = (fileInput.files as FileList)[0];

  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = (e) => {
    if (e.target) {
      formFields.value.image = e.target.result;
    }
  };
}
async function submitForm() {
  formFields.value.customer_id = props.customerId;
  formErrors.value = {};
  formSubmitting.value = true;
  showSuccess.value = false;
  let url = `customer_photos/?id=${props.customerId}&facilityId=${props.facilityId}`;

  let body = new FormData();
  if (api_settings.photo_upload && fileInput.value && fileInput.value.files) {
    url += "&attachment_type=" + chosenAttachment.value;
    body.append("attachments", fileInput.value.files[0]);
  } else {
    if (fileInput.value && fileInput.value.files) {
      body.append("image", fileInput.value.files[0]);
    }
  }

  const responseData = await api({
    url,
    method: "POST",
    body,
  });
  formSubmitting.value = false;

  if ([200, 201].includes(responseData.status)) {
    if (setToProfilePicture.value) {
      await setProfilePicture(body);
      getCustomer();
    }
    if (!api_settings.photo_upload) {
      getPhotos();
    } else {
      showSuccess.value = true;
    }
    formFields.value.image = null;
    fileInput.value = null;
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

async function setProfilePicture(body: FormData) {
  let url = `profile_picture/?id=${props.customerId}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "PUT",
    body: body,
  });
  if ([200, 201].includes(responseData.status)) {
    getPhotos();
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  }
}
async function getPhotos() {
  errors.value = "";
  const response = await api({
    url: `customer_photos/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    photos.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function deletePicture(id: string) {
  let url = `profile_picture/?id=${id}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "DELETE",
  });
  if ([200, 201].includes(responseData.status)) {
    getPhotos();
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  }
}
async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customer.value = response.body;
    profilePicture.value = customer.value.photo_identification;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
if (!api_settings.photo_upload) {
  getPhotos();
}
getCustomer();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      to: 
      !_unref(api_settings).photo_upload
        ? {
            name: 'customer_detail_ess',
            params: { id: __props.customerId, facilityId: __props.facilityId },
          }
        : {
            name: 'customer_detail_storedge',
            params: { id: __props.customerId, facilityId: __props.facilityId },
          }
    
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("h1", null, _toDisplayString(__props.customerName) + " Photos", 1),
    _createElementVNode("form", {
      class: "row",
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("img", {
            src: formFields.value.image,
            class: "uploading-image"
          }, null, 8, _hoisted_6),
          _createElementVNode("input", {
            ref_key: "fileInput",
            ref: fileInput,
            type: "file",
            accept: "image/jpeg, image/png",
            onChange: uploadImage
          }, null, 544),
          (_unref(api_settings).photo_upload)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((chosenAttachment).value = $event)),
                  required: "",
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachmentTypes.value, (attachment) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: attachment.description + 'attachment',
                      value: attachment.value
                    }, _toDisplayString(attachment.description), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, chosenAttachment.value]
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_unref(api_settings).photo_upload)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((setToProfilePicture).value = $event)),
                class: "form-check-input",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, setToProfilePicture.value]
              ]),
              _hoisted_11,
              _hoisted_12,
              _hoisted_13
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-blue",
          disabled: formSubmitting.value || !formFields.value.image
        }, " Upload Photo ", 8, _hoisted_14),
        (formSubmitting.value)
          ? (_openBlock(), _createBlock(BaseSpinner, {
              key: 1,
              preset: "large"
            }))
          : _createCommentVNode("", true),
        (showSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Successfully Uploaded"))
          : _createCommentVNode("", true)
      ]),
      (profilePicture.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("img", {
              src: profilePicture.value,
              width: "120"
            }, null, 8, _hoisted_18)
          ]))
        : _createCommentVNode("", true)
    ], 40, _hoisted_1),
    (!_unref(api_settings).photo_upload)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _hoisted_20,
          (photos.value.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, "No photos have been uploaded yet."))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value, (photo) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: photo.id + 'photo',
                    class: "well margin text-center column"
                  }, [
                    _createElementVNode("img", {
                      src: photo.url,
                      width: "100",
                      style: {"margin":"auto"}
                    }, null, 8, _hoisted_23),
                    _createElementVNode("button", {
                      class: "btn",
                      onClick: ($event: any) => (deletePicture(photo.id))
                    }, "Delete", 8, _hoisted_24)
                  ]))
                }), 128))
              ]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})